<div class="container">
  <h1>
    @if (projectInfo?.ProjectName) {
      <span>
        {{ projectInfo?.ProjectName }}
      </span>
    } @else {
      Project Name
    }
  </h1>

  @if (projectInfo?.ProjectName) {
    <h3>Thank you for taking the survey for {{ projectInfo?.ProjectName }}!</h3>
  }

  <div class="step">
    <p>Please enter your information to register for the survey.</p>
  </div>

  @if (!registrationForm.value['isAnonymous']) {
    <app-global-search-stakeholder
      (formResult)="handleStakeholderSearchResult($event)"
      (formValidity)="handleFormValidity($event)"
      [emitOnSubmit]="onStakeholderSearch"
      [removeOnBlur]="true"
    ></app-global-search-stakeholder>
  }

  <form [formGroup]="registrationForm" aria-label="Survey Registration Form" class="survey-registration-form">
    <mat-checkbox [formControlName]="'isAnonymous'" [aria-label]="'I prefer to submit my response anonymously'">
      I prefer to submit my response anonymously
    </mat-checkbox>
  </form>
  <div
    class="button-row"
    [ngClass]="{
      'button-row-margin': !registrationForm.value['IsMultipleAttending'],
    }"
  >
    <button class="blue-button" [class.disabled]="isSubmitDisabled()" (click)="onRegisterForSurvey()">Continue</button>
  </div>
</div>
